import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router';
import { ASSET_WRITE, canUserShare, hasPrivilege } from 'utils/privileges';
import createLocation from 'utils/createLocation';
import { NavMenu, NavMenuButton, NavMenuDivider, NavMenuItem, NavMenuList } from 'components/NavMenu';
import useBreakpoints from 'hooks/useBreakpoints';
import AssetViewer from 'screens/SimpleAssetViewer';
import { ChangelogOption, GetShareableContentLinkOption, ShareContentOption } from 'screens/SinglePlaylistManager';
export function AssetHeaderOptionsMenu(_ref) {
  var _ref$hasOpenOption = _ref.hasOpenOption,
    hasOpenOption = _ref$hasOpenOption === void 0 ? true : _ref$hasOpenOption,
    asset = _ref.asset,
    parentPlaylistId = _ref.parentPlaylistId,
    shareData = _ref.shareData;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useBreakpoints = useBreakpoints('m'),
    isDesktop = _useBreakpoints.m;
  var location = useLocation();
  var history = useHistory();
  var canShareAsset = !asset.isDeleted && canUserShare();
  var hasMenu = canShareAsset || hasPrivilege(ASSET_WRITE);
  if (!hasMenu) {
    return null;
  }
  function openAsset() {
    history.push(createLocation(location, {
      assetId: asset.id
    }));
  }
  return /*#__PURE__*/React.createElement(NavMenu, {
    id: "advanced-options-menu",
    menuPlacement: "bottom-end"
  }, /*#__PURE__*/React.createElement(NavMenuButton, {
    variant: "transparent",
    iconRight: "tools",
    iconOnly: !isDesktop
  }, t('actions_more_options')), /*#__PURE__*/React.createElement(NavMenuList, null, canShareAsset && shareData && /*#__PURE__*/React.createElement(ShareContentOption, {
    shareData: shareData,
    modalQueryParam: "share-asset"
  }), canShareAsset && /*#__PURE__*/React.createElement(GetShareableContentLinkOption, {
    contentId: asset.id,
    parentPlaylistId: parentPlaylistId,
    type: "asset",
    modalQueryParam: "share-asset-link"
  }), hasPrivilege(ASSET_WRITE) && /*#__PURE__*/React.createElement(React.Fragment, null, canShareAsset && /*#__PURE__*/React.createElement(NavMenuDivider, null), /*#__PURE__*/React.createElement(ChangelogOption, {
    contentId: asset.id
  })), hasOpenOption && /*#__PURE__*/React.createElement(NavMenuItem, {
    onClick: openAsset
  }, t('actions_open'))), /*#__PURE__*/React.createElement(AssetViewer, null));
}
export default AssetHeaderOptionsMenu;